import { useState, useEffect } from 'react';
import { GetOpsLocations } from '../libs/GraphQL';
import { track } from 'logrocket';

const OPERATING_MODEL_LIST = ['BBS', 'Consignment', 'Traditional'];

export default function useGetRetailers({
  type = 'WHOLESALE',
  status = ['LIVE'],
  trackEvent = null,
  trackOptions = {},
} = {}) {
  const [retailerList, setRetailerList] = useState([]);
  const [errors, setErrors] = useState(null);

  useEffect(() => {
    GetOpsLocations({ type, status })
      .then((response) => {
        const locations = response.data.opsLocations.locations;
        const result = locations.filter((item) =>
          OPERATING_MODEL_LIST.includes(item.operatingModel),
        );
        const retailers = result
          .filter(
            (item) => item.retailer, // Exclude items with null/undefined retailer
          )
          .map((item) => ({
            name: item.retailer,
            id: item.id,
          }));
        // Build object with unique retailer names as keys and array of ids as values
        const retailerIdMap = {};
        retailers.forEach(({ name, id }) => {
          if (!retailerIdMap[name]) {
            retailerIdMap[name] = [];
          }
          retailerIdMap[name].push(id);
        });
        setRetailerList(retailerIdMap);
      })
      .catch((err) => {
        if (trackEvent) {
          track(trackEvent, {
            ...trackOptions,
            error: err,
          });
        }
        setErrors(err);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return { retailerList, errors };
}
